import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, initialize, destroy } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import SearchCityStateField from 'components/forms/SearchCityStateField'
import Svg from 'components/util/Svg'
import { Button } from 'components/util'
import styles from './_searchCityStateForm.css'

export const FORM_NAME = 'searchCityState'

const validate = () => {
  const errors = {}
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class SearchCityStateForm extends Component {
  static propTypes = {
    initialize: PropTypes.func,
    handleSubmit: PropTypes.func,
    destroy: PropTypes.func,
  }

  arrowRenderer () {
    return (
      <Svg name='ic-current-location' className={styles.currentLocation} />
    )
  }

  render () {
    const {
      handleSubmit,
    } = this.props

    return (
      <div className={styles.searchCityForm}>
        <form method='post' onSubmit={handleSubmit}>
          <div className={styles.searchField}>
            <Svg name='ic-location' className={styles.currentLocation} />
            <SearchCityStateField
              arrowRenderer={this.arrowRenderer}
              name='city'
              placeholder='Search Any City or State'
              required={true}
              className={styles.searchTextField}
              fromPanama={true}
            />
            <Button
              el='button'
              type='success'
              className={styles.goButton}
            >
              <FormattedMessage
                id='route.landing.go'
                defaultMessage='Go'
              />
            </Button>
          </div>
        </form>
      </div>
    )
  }

}

export const Form = reduxForm(formOptions)(SearchCityStateForm)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(Form)
